<template>
  <div class="home">
      <div class="bCon" id="top">
          <banner-Component :banner="data.banner" ></banner-Component>
          <div class="down">
              <div class="goDown" @click="goDown">
                  <img src="../assets/ycb/mouse.png" alt="">
              </div>
              <div class="line" id="intro">

              </div>
          </div>
      </div>

   <div class="main" >

<!--       公司介绍-->
       <div class="about">
           <div class="aBg">
               <img src="../assets/aem/abg.png" alt="">
           </div>
           <div class="content">
            <div class="left wow">
             <div class="title ">
                    <p>关于波登斯特</p>
<!--                 <p> Amuer brings you the pure elegant life</p>-->
             </div>
                <div class="nr">
                    <p>
                        BODENstil，始创于1865年，是一个享誉欧亚大陆的德国木地板品牌。历经一百多年的沉淀与积累，BODENSTIL从普鲁士时代的一个小作坊逐渐发展成为新时代的实力木地板生产商。扎根德国，辐射全球，BODENSTIL在全球十几个国家均拥有长期战略合作伙伴，凭借严谨细致的德式产品观念，BODENSTILE百余年来，备受全球客户赞誉与认可。<br>
                        2016年，BODENSTIL为适应更广阔的市场需求，整合自身资源优势，在中国注册品牌“波登斯特”，专注于实木复合地板的生产、研发和销售，并首次提出了“愉悦家居主义”，旨在通过为客户提供更高品质、更多样化、更健康环保的实木复合地板，引导大家去追求一种更清新更愉悦的生活态度。
                    </p>
                    <aBtn page="about"></aBtn>
                </div>
                <div class="play">
                 <i class="iconfont icon-bofang"></i>
                    <div class="dot">
                      <span></span>
                    </div>
                </div>
            </div>
               <div class="right wow">
                   <img src="../assets/aem/ar.png" alt="">
               </div>
           </div>
       </div>



<!--       产品中心-->
       <mpro  :products="data.products" />


       <!--       案例中心-->
       <news  :cases="data.cases" />





   </div>
      <foot-Component class="foot wow fadeIn" @goTop="goTop"></foot-Component>
  </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import Scrollbar from 'smooth-scrollbar'
  import footComponent from '../components/foot'
  import aBtn from '../components/btn'
  import mpro from '../components/mpro'
  import news from '../components/news'
  import  {getHomeInfo} from "../util/lang";

  export default {
  name: 'home',
    data(){
      return{
          scrollbar:'',
          data:{}
      }
    },
    mounted() {
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,0)
        this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
        window.pageYOffset=this.scrollbar.scrollTop
        this.scrollbar.addListener((status) => {

        });
           setTimeout(()=>{
               this.getNews()
           },100)
    },
  components:{bannerComponent,footComponent,mpro,news,aBtn},
    methods:{
        goTop(){
            Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#top"))
        },
        getNews(){
            const url = `${getHomeInfo()}`
            this.$axios.get(url).then(res => {
                this.data=res.data
            })
        },
        goDown(){
            Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#intro"))
        },
        gotoAbout(){
            const link='/about.html'
            window.open(link,'_self')
        }
    }
}
</script>

<style lang="scss" scoped>
    .home {
        width: 100%;
        animation: run5 1s linear forwards;
        perspective: 2000px;
        @keyframes run5 {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
        .bCon {
            position: relative;
            height: 100vh;
            overflow: hidden;
            width: 100%;
            background-color: black;
            &::before {
                content: "";
                display: inline-block;
                height: 100%;
                width: 100%;
                background: rgba(215, 199, 165, 0.15);
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1000;
                pointer-events: none;
            }
            .bf {
                position: absolute;
                left: 0;
                bottom: 40%;
                width: 100%;
                text-align: center;
                z-index: 100;
                img {
                    cursor: pointer;
                }
            }
            .down {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                z-index: 100;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .goDown {
                    img {
                        cursor: pointer;
                    }
                }
                .line {
                    width: 1px;
                    height: 84px;
                    background: rgba(255, 255, 255, 0.3);
                    position: relative;
                    &::before {
                        content: "";
                        display: inline-block;
                        height: 20px;
                        width: 1px;
                        background-color: white;
                        position: absolute;
                        left: 0;
                        top: 0;
                        animation: run 3s infinite linear;
                    }
                }
                @keyframes run {
                    from {
                        top: 0;
                    }
                    to {
                        top: 100%;
                    }
                }
            }
        }
        .main {
            width: 100%;
            .about {
                width: 100%;
                position: relative;
                .aBg {
                    width: 100%;
                    img {
                        width: 100%;
                        display: block;
                        object-fit: cover;
                        height: 1100px;
                    }
                }
                .content {
                    width: 90%;
                    top: 200px;
                    left: 10%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    position: absolute;
                    .left {
                        width: 28%;
                        margin-top: 30px;
                        animation: transition1 1s forwards linear;
                        z-index: 100;
                        .title {
                            p:nth-child(1) {
                                font-size: 24px;
                                font-family: "DINNeuzeitGroteskStd-Light";
                                text-transform: uppercase;
                            }
                            p:nth-child(2) {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                font-family: "it";
                                font-weight: lighter;
                                font-size: 14px;
                                margin: 15px auto;
                                &::before {
                                    width: 30px;
                                    height: 1px;
                                    background: rgba(187, 187, 187, 1);
                                    content: "";
                                    display: inline-block;
                                    margin-right: 10px;
                                }
                            }
                        }
                        .nr {
                            width: 120%;
                            background: rgba(42, 41, 41, 1);
                            padding: 50px 100px;
                            opacity: 0.4;
                            margin: 60px auto;
                            z-index: 100;
                            p {
                                color: white;
                                font-family: "it";
                                font-size: 14px;
                                line-height: 34px;
                            }
                        }
                        .play {
                            width: 90px;
                            height: 90px;
                            border: 1px solid rgba(42, 41, 41, 0.1);
                            border-radius: 50%;
                            margin: 40px 0 0 5%;
                            text-align: center;
                            cursor: pointer;
                            position: relative;
                            i {
                                color: #2a2929;
                                line-height: 90px;
                                font-size: 20px;
                            }
                            .dot {
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 100%;
                                height: 100%;
                                border-radius: 50%;
                                animation: rotate 4s infinite linear;
                                span {
                                    display: inline-block;
                                    width: 4px;
                                    height: 4px;
                                    background: rgba(97, 96, 90, 1);
                                    border-radius: 50%;
                                    position: absolute;
                                    top: 40%;
                                    left: -2px;
                                }
                                @keyframes rotate {
                                    from {
                                        transform: rotate(0);
                                    }
                                    to {
                                        transform: rotate(360deg);
                                    }
                                }
                            }
                        }
                    }
                    .right {
                        width: 70%;
                        overflow: hidden;
                        animation: transition2 1s forwards linear;
                        img {
                            width: 100%;
                            display: block;
                            object-fit: cover;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .foot {
            animation-duration: 5s;
        }
        @keyframes transition1 {
            0% {
                transform: translate(-100px, -100px);
                opacity: 0;
            }
            100% {
                transform: translate(0, 0);
                opacity: 1;
            }
        }
        @keyframes transition2 {
            0% {
                transform: translate(100px, -100px);
            }
            100% {
                transform: translate(0, 0);
            }
        }
        @keyframes polygon {
            0% {
                clip-path: polygon(100% 0, 99% 50%, 50% 99%, 100% 50%);
                opacity: 0;
            }
            100% {
                clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
                opacity: 1;
            }
        }
        @media screen and (max-width: 1000px) {
            .main {
                .about {
                    margin: 30px auto;
                    width: 90%;
                    padding-bottom: 0px;
                    .content {
                        top: 20px;
                        width: 95%;
                        left: 2.5%;
                        flex-direction: column;
                        .left {
                            width: 100%;
                            .nr {
                                margin: 230px auto 20px auto;
                                width: 90%;
                                padding: 20px 5%;
                            }
                            .play{
                                width: 50px;
                                height: 50px;
                                margin-top: 20px;
                                i{
                                    line-height: 50px;
                                }
                            }
                        }
                        .right {
                            width: 100%;
                            position: absolute;
                            top: 120px;
                        }
                    }
                    .title {
                        p:nth-child(1) {
                            font-size: 24px;
                        }
                        p:nth-child(2) {
                            font-size: 20px;
                        }
                    }
                    .intro {
                        margin: 15px auto;
                        line-height: 40px;
                        width: 100%;
                    }
                }
            }
        }
    }
</style>
